<!-- 修改密码弹窗 -->
<template>
  <el-dialog width="600px" :visible="visible" :lock-scroll="false" :append-to-body="true" custom-class="password-dialog"
    @update:visible="updateVisible" @closed="onClose">
    <!-- 自定义标题 -->
    <div slot="title" class="dialog-title">
      <div class="title-icon">
        <i class="el-icon-lock"></i>
      </div>
      <span>修改密码</span>
    </div>
    
    <el-form ref="form" :model="form" :rules="rules" label-width="95px" @keyup.enter.native="save" class="password-form">
      <el-form-item label="旧密码:" prop="oldPassword">
        <el-input show-password v-model="form.oldPassword" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="新密码:" prop="newPassword">
        <el-input show-password v-model="form.newPassword" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="确认密码:" prop="rePassword">
        <el-input show-password v-model="form.rePassword" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-btns">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'UpdatePwd',
  props: {
    visible: Boolean
  },
  data() {
    return {
      // 表单数据
      form: {
        oldPassword: '',
        newPassword: '',
        rePassword: ''
      },
      // 表单验证
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        rePassword: [
          {
            required: true,
            message: '请再次输入新密码',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('请再次输入新密码'));
              } else if (value !== this.form.newPassword) {
                return callback(new Error('两次输入密码不一致'));
              }
              callback();
            }
          }
        ]
      },
      // 按钮loading
      loading: false
    };
  },
  methods: {
    /* 保存修改 */
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http.post('/index/updatePwd', this.form).then((res) => {
            this.loading = false;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              this.cancel();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /* 关闭回调 */
    onClose() {
      this.form = {};
      this.$refs['form'].resetFields();
      this.loading = false;
    },
    /* 取消 */
    cancel() {
      this.updateVisible(false);
    },
    /* 修改visible */
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped>
/* 自定义弹窗样式 */
::v-deep .password-dialog {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .password-dialog .el-dialog__header {
  padding: 30px 30px 20px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-bottom: 2px solid #f0f2f5;
}

::v-deep .password-dialog .el-dialog__body {
  padding: 30px;
}

::v-deep .password-dialog .el-dialog__footer {
  padding: 20px 30px 30px;
  border-top: 1px solid #f0f2f5;
}

/* 标题美化 */
.dialog-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.title-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.title-icon i {
  font-size: 28px;
  color: white;
}

.dialog-title span {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

/* 表单美化 */
.password-form .el-form-item {
  margin-bottom: 25px;
}

::v-deep .el-input__inner {
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.3s ease;
}

::v-deep .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

/* 按钮美化 */
.dialog-footer-btns {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

::v-deep .el-button {
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

::v-deep .el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

::v-deep .el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

::v-deep .el-button--default {
  background: #f5f7fa;
  border-color: #dcdfe6;
  color: #606266;
}

::v-deep .el-button--default:hover {
  background: #e6e8eb;
  border-color: #c0c4cc;
  color: #303133;
}
</style>

